import { authFetch } from './authFetch';
export async function publishMovie(movieId) {
    const response = await authFetch(`/api/movies/${movieId}/publish`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
    });
    if (!response.ok) {
        let message = `Publish failed (${response.status})`;
        try {
            const body = (await response.json());
            if (body.error)
                message = body.error;
        }
        catch {
            // ignore
        }
        throw new Error(message);
    }
    return (await response.json());
}
export function resolvePlayerUrl(result) {
    if (result.playerUrl)
        return result.playerUrl;
    const origin = import.meta.env.VITE_PLAYER_PUBLIC_ORIGIN?.replace(/\/$/, '')
        ?? 'http://localhost:4100';
    return `${origin}${result.playerPath}`;
}
